const baseMixin = {
	methods: {
		plural(singular, plural, nb) {
			if (nb == 1) {
				return singular;
			}
			return plural;
		},
		isEmpty(obj) {
			for (var key in obj) {
				if (obj.hasOwnProperty(key))
					return false;
			}
			return true;
		},
		getDate(days = 0) {
			let date = new Date();
			date.setDate(date.getDate() + days);
			let dd = String(date.getDate()).padStart(2, '0');
			let mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
			let yyyy = date.getFullYear();
			return yyyy + '-' + mm + '-' + dd;
		}
	}
}